/**
 * Xato to'sig'i (error boundary).
 *
 * NEGA KERAK: React'da bitta komponentdagi ushlanmagan xato BUTUN
 * daraxtni yiqitadi. To'siq bo'lmasa foydalanuvchi Telegram ichida
 * shunchaki bo'sh ekran ko'radi — na sabab, na chiqish yo'li.
 *
 * Bu haqiqatan sodir bo'ldi: `Detail.tsx` da ikonka importi tushib
 * qolganda ilova butunlay oq bo'lib qoldi.
 *
 * To'siq FAQAT render paytidagi xatolarni ushlaydi. Voqea
 * ishlovchilaridagi va async koddagi xatolar `main.tsx` dagi global
 * tinglovchilarga tushadi.
 */

import { Component, type ErrorInfo, type ReactNode } from "react";
import { IconAlert } from "./icons";
import { t } from "./i18n";

interface Props {
  children: ReactNode;
  /** O'zgarganda to'siq tiklanadi — masalan marshrut. */
  resetKey?: string;
}

interface State {
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // Konsolga chiqaramiz — Telegram ichida boshqa tashxis vositasi yo'q.
    // Ishlab chiqarishda bu yerdan Sentry'ga yuborilishi mumkin (TZ §4.2).
    console.error("Render xatosi:", error, info.componentStack);
  }

  componentDidUpdate(prev: Props): void {
    // Boshqa ekranga o'tilganda to'siqni tiklaymiz: bitta buzuq
    // sahifa butun ilovani abadiy qulflab qo'ymasligi kerak.
    if (this.state.error && prev.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render(): ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="center">
        <div className="state-icon state-icon-danger">
          <IconAlert size={26} />
        </div>
        <p className="empty-title">{t("error.title")}</p>
        <p className="muted">
          {t("error.hint")}
        </p>
        <button
          className="btn btn-primary"
          type="button"
          onClick={() => window.location.reload()}
        >
          {t("error.reload")}
        </button>
        {/* Texnik tafsilot faqat ishlab chiqishda — foydalanuvchiga
            stack trace ko'rsatishning ma'nosi yo'q. */}
        {import.meta.env.DEV ? (
          <pre className="error small" style={{ whiteSpace: "pre-wrap" }}>
            {error.message}
          </pre>
        ) : null}
      </div>
    );
  }
}
